
import React, { Component } from "react";

class PostFAQ extends Component {

  constructor(props) {
    super(props);
    this.state = { activeFaq: 0 };
    this.propertyData = {
      faqs: [
        { q: "What time is check-in and check-out?", a: "Check-in is at 2:00 PM and check-out is at 11:00 AM. Early check-in or late check-out can be requested subject to availability." },
        { q: "Is the swimming pool private?", a: "Yes, the infinity pool is 100% private and exclusively for your use during your stay." },
        { q: "Do you offer airport shuttle services?", a: "Yes, we offer luxury airport transfers. It costs $45 one way. Please share your flight details to book." },
        { q: "Are pets allowed on the property?", a: "To maintain the pristine condition of the villa, we do not allow pets." },
        { q: "Is breakfast included in the price?", a: "Yes, a complimentary daily floating breakfast in the pool is included for all guests." },
        { q: "How fast is the WiFi?", a: "We have a dedicated fiber-optic connection with speeds up to 150 Mbps." },
        { q: "Can we request a baby crib?", a: "Absolutely. We can provide a baby crib and high chair free of charge." },
        { q: "Is there a washing machine available?", a: "Yes, the villa includes a fully equipped laundry room." },
        { q: "Is the area safe for walking at night?", a: "Yes, Ubud is very safe. The villa also has 24/7 security." },
        { q: "What is the cancellation policy?", a: "You can cancel for free up to 7 days before check-in. Cancellations made within 7 days are subject to a 50% charge." }
      ]
    };
  }
  toggleFaq = (index) => this.setState(p => ({ activeFaq: p.activeFaq === index ? null : index }));
  render() {
    const { activeFaq } = this.state;
    const { faqs } = this.propertyData;
    return (
      <>
        <section className="mb-5 pb-lg-5">
          <h3 className="fw-bold mb-4 section-heading">Frequently Asked Questions</h3>
          <div className="custom-accordion">
            {faqs.map((faq, index) => (
              <div key={index} className="accordion-item mb-3 bg-white border rounded-3 overflow-hidden shadow-sm">
                <button
                  className={`accordion-btn w-100 d-flex justify-content-between align-items-center p-4 border-0 bg-transparent text-start fw-bold fs-6 ${activeFaq === index ? 'text-primary-green' : 'text-dark'}`}
                  onClick={() => this.toggleFaq(index)}
                >
                  {faq.q}
                  <i className={`fas fa-chevron-down transition-icon ${activeFaq === index ? 'rotate-180' : ''}`}></i>
                </button>
                <div className={`accordion-collapse ${activeFaq === index ? 'open' : ''}`}>
                  <div className="p-4 pt-0 text-secondary lh-lg border-top border-light mt-2">
                    {faq.a}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </section>
      </>
    );
  }
}
export default PostFAQ;
